'use client'
import { memo, useMemo } from 'react'
import type { FC } from 'react'
import { useModal } from '@/hooks'
import { MODALS } from '@/context'
import { Modal } from '..'
import { dialogStyles, Wrapper } from './modalMobileMenuStyles'
import { dialogVariants } from './modalMobileMenuVariants'
import { useTranslator } from '@/hooks'
import { getFooterLinks, getFooterInfo } from '@/components/layout/Footer'
import { getSeasonSchedule } from '@/utils'

const FooterLinks = getFooterLinks('iluzione')
export const ModalMenu:FC = memo(() => {
  const { isActive, toggle } = useModal(MODALS.MENU)
  const { t } = useTranslator()
  const seasonInfo = getSeasonSchedule('iluzione')
  const FooterInfo = useMemo(() => getFooterInfo(t, seasonInfo), [t, seasonInfo])

  return(
    <Modal isActive={isActive} close={toggle} title='Menu' xAlign='flex-start' variants={dialogVariants} dialogStyles={dialogStyles} hasHeader={false} zIndex={95} isModalFilters={true} className={'just-mobile'}>
      {FooterInfo}
      <Wrapper>
        {FooterLinks}
      </Wrapper>
    </Modal>
  )
})
